<script>
import { mapGetters } from 'vuex'
import table from './categories.table'
import getExportedFilename from '@lib/utils/get-exported-filename'
import categoryModal from '../category/product-category-modal'

export default {
  name: 'ProductCategories',
  page: {
    title: 'Product Categories',
  },
  components: {
    categoryModal,
  },
  data() {
    return {
      table: null,
      loading: false,
      modals: {
        create: false,
      },
    }
  },
  computed: {
    ...mapGetters('me', ['canCreateCategory']),
    ...mapGetters('categories', ['categories']),
  },
  created() {
    this.table = table(this)
  },
  methods: {
    onRowClick(row) {
      this.$router.push({
        name: 'product-category',
        params: {
          id: row.id,
        },
      })
    },
    getExportedFilename() {
      return getExportedFilename(this.table.tableName)
    },
  },
}
</script>

<template>
  <main-layout title="Product Categories">
    <table-layout
      :columns="table.columns"
      :export-filename="getExportedFilename"
      :filters="table.filters"
      :fragments="false"
      :processor="table.processor"
      :quantity="[25, 50, 100, 200]"
      :table-name="table.tableName"
      hider
      @row-click="onRowClick"
    />
    <el-button
      v-if="canCreateCategory"
      slot="header"
      type="primary"
      data-test="add"
      class="el-button--wide"
      @click="modals.create = true"
    >
      Create Product Category
    </el-button>

    <category-modal
      v-if="modals.create"
      :visible.sync="modals.create"
    />
  </main-layout>
</template>
